import React from 'react';
import { LinkButton, UIHeading4, UIText2 } from '@cian/ui-kit';

import { Telegram40 } from '../Icons';
import { ITelegramLinkData } from '../../types/telegramLinkData';
import * as s from './PostTelegramLink.css';

/**
 * Блок-ссылка на Телеграм-канал
 */
export const PostTelegramLink = ({ label, link, title }: ITelegramLinkData) => (
  <div className={s['wrapper']}>
    <div className={s['content-wrapper']}>
      <Telegram40 />

      <div>
        <UIHeading4>Наш канал в Telegram</UIHeading4>
        <UIText2>{label}</UIText2>
      </div>
    </div>

    <LinkButton theme={'fill_primary'} fullWidth href={link} title={title} target={'_blank'}>
      Подписаться
    </LinkButton>
  </div>
);
